var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupAlHalal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.99,
    y: 46.14,
    width: 99.74,
    height: 129.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8,144.3a.82.82,0,0,1,.49.08,1.59,1.59,0,0,1,.87,1.13,1.53,1.53,0,0,1-.14,1.05,1.82,1.82,0,0,1-1,.82,1.88,1.88,0,0,1-1.45,0,2.42,2.42,0,0,1-1.14-1.16,3.7,3.7,0,0,1,.38-3.58,3.74,3.74,0,0,1,1.53-1.41,2.35,2.35,0,0,1,1.09-.24,2.24,2.24,0,0,1,1.09.36,3.89,3.89,0,0,1,1.38,1.86,8.47,8.47,0,0,1,.48,2.35,8.76,8.76,0,0,1-1.15,4.84,31.67,31.67,0,0,1-3,4A11.92,11.92,0,0,0,26,158.24a5.46,5.46,0,0,0,.26,4,3.12,3.12,0,0,0,2.82,1.73,2.56,2.56,0,0,0,1.43-.45,2,2,0,0,0,.75-1.08,2.62,2.62,0,0,0-.38-2.1,1.83,1.83,0,0,0-1.09-.8,1.32,1.32,0,0,0-.37,0h-.12s0,0,.12,0a1,1,0,0,1,.38,0,1.81,1.81,0,0,1,1.19.79,2.78,2.78,0,0,1,.45,2.22,2.1,2.1,0,0,1-.81,1.2,2.7,2.7,0,0,1-1.54.51A3.32,3.32,0,0,1,26,162.33a5.72,5.72,0,0,1-.31-4.17,12,12,0,0,1,2.3-4A29.86,29.86,0,0,0,31,150.19a8.47,8.47,0,0,0,1.12-4.66,7.89,7.89,0,0,0-.45-2.25,3.65,3.65,0,0,0-1.25-1.73,1.88,1.88,0,0,0-1.9-.11,3.5,3.5,0,0,0-1.42,1.3,3.44,3.44,0,0,0-.4,3.33,2.22,2.22,0,0,0,1,1.07,1.68,1.68,0,0,0,2.18-.66,1.37,1.37,0,0,0,.16-.95,1.55,1.55,0,0,0-.78-1.09A1.94,1.94,0,0,0,28.8,144.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.67,132.53a.88.88,0,0,1-.5-.07,1.62,1.62,0,0,1-.87-1.13,1.53,1.53,0,0,1,.14-1.05,1.82,1.82,0,0,1,1-.82,1.86,1.86,0,0,1,1.46,0A2.51,2.51,0,0,1,32,130.66a3.72,3.72,0,0,1-.39,3.59,3.84,3.84,0,0,1-1.52,1.41,2.37,2.37,0,0,1-1.09.23,2.18,2.18,0,0,1-1.1-.36,3.89,3.89,0,0,1-1.38-1.86,8,8,0,0,1-.47-2.35,8.62,8.62,0,0,1,1.15-4.83,30.13,30.13,0,0,1,3-4,11.54,11.54,0,0,0,2.26-3.91,5.49,5.49,0,0,0-.25-4,3.13,3.13,0,0,0-2.83-1.73,2.5,2.5,0,0,0-1.42.45,2,2,0,0,0-.76,1.08,2.7,2.7,0,0,0,.38,2.1,1.74,1.74,0,0,0,1.1.8,1.34,1.34,0,0,0,.36,0h.13s0,0-.13,0a1.12,1.12,0,0,1-.37,0,1.79,1.79,0,0,1-1.19-.8,2.76,2.76,0,0,1-.46-2.21,2.26,2.26,0,0,1,.81-1.21,2.79,2.79,0,0,1,1.55-.51,3.33,3.33,0,0,1,1.73.44,3.24,3.24,0,0,1,1.34,1.4,5.77,5.77,0,0,1,.3,4.17,11.85,11.85,0,0,1-2.3,4,32.61,32.61,0,0,0-2.95,3.94,8.36,8.36,0,0,0-1.11,4.66,7.63,7.63,0,0,0,.45,2.25,3.59,3.59,0,0,0,1.24,1.72,1.9,1.9,0,0,0,1.91.11,3.82,3.82,0,0,0,1.82-4.62,2.28,2.28,0,0,0-1-1.08,1.64,1.64,0,0,0-1.3-.06,1.66,1.66,0,0,0-.89.72,1.36,1.36,0,0,0-.15,1,1.53,1.53,0,0,0,.77,1.1A1.6,1.6,0,0,0,29.67,132.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.24,138.18a1,1,0,1,1-1-1A1,1,0,0,1,30.24,138.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.67,
    cy: 111.16,
    r: 1.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.24,77.92a2.08,2.08,0,0,0,.47-.14,1.56,1.56,0,0,0,.77-1.1,1.32,1.32,0,0,0-.16-1,1.56,1.56,0,0,0-.88-.72,1.64,1.64,0,0,0-1.3.06,2.28,2.28,0,0,0-1,1.08,3.82,3.82,0,0,0,1.82,4.64,1.88,1.88,0,0,0,1.91-.12,3.57,3.57,0,0,0,1.24-1.73,7.63,7.63,0,0,0,.45-2.25A8.5,8.5,0,0,0,31.42,72a30.75,30.75,0,0,0-3-4,12.06,12.06,0,0,1-2.3-4,5.75,5.75,0,0,1,.31-4.18,3.36,3.36,0,0,1,1.33-1.41A3.44,3.44,0,0,1,29.55,58a2.71,2.71,0,0,1,1.54.52,2.1,2.1,0,0,1,.81,1.2,2.77,2.77,0,0,1-.45,2.22,1.78,1.78,0,0,1-1.19.8,1,1,0,0,1-.38,0l-.12,0h.13a1.28,1.28,0,0,0,.36,0,1.79,1.79,0,0,0,1.09-.81,2.62,2.62,0,0,0,.38-2.1A1.9,1.9,0,0,0,31,58.69a2.54,2.54,0,0,0-1.43-.46A3.11,3.11,0,0,0,26.72,60a5.49,5.49,0,0,0-.26,4,11.92,11.92,0,0,0,2.26,3.92,31,31,0,0,1,3,4,8.74,8.74,0,0,1,1.15,4.84,8,8,0,0,1-.48,2.35A3.79,3.79,0,0,1,31,80.92a2.19,2.19,0,0,1-1.1.37,2.38,2.38,0,0,1-1.09-.24,3.8,3.8,0,0,1-1.53-1.41,3.72,3.72,0,0,1-.38-3.59,2.4,2.4,0,0,1,1.14-1.17,1.88,1.88,0,0,1,1.45,0,1.81,1.81,0,0,1,1,.83,1.42,1.42,0,0,1,.14,1,1.57,1.57,0,0,1-.87,1.13A.82.82,0,0,1,29.24,77.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54,89.72a1.6,1.6,0,0,0-.47.13A1.53,1.53,0,0,0,28.3,91a1.39,1.39,0,0,0,.15,1,1.66,1.66,0,0,0,.89.72,1.64,1.64,0,0,0,1.3-.06,2.28,2.28,0,0,0,1-1.08,3.49,3.49,0,0,0-.4-3.34,3.56,3.56,0,0,0-1.42-1.3,1.88,1.88,0,0,0-1.91.12,3.52,3.52,0,0,0-1.24,1.73A7.56,7.56,0,0,0,26.24,91a8.49,8.49,0,0,0,1.11,4.67,32.73,32.73,0,0,0,2.95,3.95,11.79,11.79,0,0,1,2.3,4,5.7,5.7,0,0,1-.3,4.18,3.28,3.28,0,0,1-1.33,1.4,3.45,3.45,0,0,1-1.74.45,2.71,2.71,0,0,1-1.54-.52,2.15,2.15,0,0,1-.81-1.21,2.79,2.79,0,0,1,.45-2.22,1.77,1.77,0,0,1,1.19-.79,1.18,1.18,0,0,1,.37,0c.09,0,.13,0,.13,0h-.13a1,1,0,0,0-.36,0,1.8,1.8,0,0,0-1.1.81,2.7,2.7,0,0,0-.38,2.1,2,2,0,0,0,.76,1.08,2.46,2.46,0,0,0,1.43.45,3.11,3.11,0,0,0,2.82-1.74,5.44,5.44,0,0,0,.25-4,11.58,11.58,0,0,0-2.26-3.92,30.91,30.91,0,0,1-3-4,8.77,8.77,0,0,1-1.15-4.85,8.11,8.11,0,0,1,.47-2.35,4,4,0,0,1,1.38-1.87,2.24,2.24,0,0,1,1.09-.36,2.4,2.4,0,0,1,1.1.24A3.84,3.84,0,0,1,31.48,88a3.72,3.72,0,0,1,.39,3.59,2.54,2.54,0,0,1-1.14,1.17,1.83,1.83,0,0,1-1.45,0,1.75,1.75,0,0,1-1-.82,1.42,1.42,0,0,1-.14-1A1.61,1.61,0,0,1,29,89.79.88.88,0,0,1,29.54,89.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.67,
    cy: 84.05,
    r: 1.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,144.3a.85.85,0,0,1,.5.08,1.62,1.62,0,0,1,.87,1.13,1.53,1.53,0,0,1-.14,1.05,1.82,1.82,0,0,1-1,.82,1.91,1.91,0,0,1-1.46,0,2.47,2.47,0,0,1-1.14-1.16,3.7,3.7,0,0,1,.39-3.58,3.77,3.77,0,0,1,1.52-1.41,2.38,2.38,0,0,1,1.09-.24,2.28,2.28,0,0,1,1.1.36,3.89,3.89,0,0,1,1.38,1.86,8.11,8.11,0,0,1,.47,2.35,8.67,8.67,0,0,1-1.15,4.84,30.68,30.68,0,0,1-3,4,11.58,11.58,0,0,0-2.26,3.92,5.46,5.46,0,0,0,.25,4,3.13,3.13,0,0,0,2.83,1.73,2.5,2.5,0,0,0,1.42-.45,2,2,0,0,0,.76-1.08,2.66,2.66,0,0,0-.38-2.1,1.82,1.82,0,0,0-1.1-.8,1.25,1.25,0,0,0-.36,0h-.13s0,0,.13,0a.9.9,0,0,1,.37,0,1.77,1.77,0,0,1,1.19.79,2.78,2.78,0,0,1,.46,2.22,2.2,2.2,0,0,1-.81,1.2,2.71,2.71,0,0,1-1.55.51,3.42,3.42,0,0,1-1.73-.43,3.36,3.36,0,0,1-1.34-1.4,5.77,5.77,0,0,1-.3-4.17,11.79,11.79,0,0,1,2.3-4,31.73,31.73,0,0,0,3-3.93,8.38,8.38,0,0,0,1.11-4.66,7.56,7.56,0,0,0-.45-2.25,3.57,3.57,0,0,0-1.24-1.73,1.9,1.9,0,0,0-1.91-.11,3.85,3.85,0,0,0-1.82,4.63,2.26,2.26,0,0,0,1,1.07,1.65,1.65,0,0,0,1.3.07,1.68,1.68,0,0,0,.89-.73,1.36,1.36,0,0,0,.15-.95,1.51,1.51,0,0,0-.77-1.09A1.93,1.93,0,0,0,113,144.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.86,132.53a.88.88,0,0,1-.5-.07,1.59,1.59,0,0,1-.87-1.13,1.53,1.53,0,0,1,.14-1.05,1.89,1.89,0,0,1,2.41-.78,2.47,2.47,0,0,1,1.14,1.16,3.72,3.72,0,0,1-.38,3.59,3.8,3.8,0,0,1-1.53,1.41,2.35,2.35,0,0,1-1.09.23,2.14,2.14,0,0,1-1.09-.36,3.89,3.89,0,0,1-1.38-1.86,8.32,8.32,0,0,1-.48-2.35,8.7,8.7,0,0,1,1.15-4.83,31.08,31.08,0,0,1,3-4,11.88,11.88,0,0,0,2.26-3.91,5.49,5.49,0,0,0-.26-4,3.12,3.12,0,0,0-2.82-1.73,2.56,2.56,0,0,0-1.43.45,2,2,0,0,0-.75,1.08,2.62,2.62,0,0,0,.38,2.1,1.75,1.75,0,0,0,1.09.8,1.41,1.41,0,0,0,.37,0h.12s0,0-.12,0a1.18,1.18,0,0,1-.38,0,1.8,1.8,0,0,1-1.18-.8,2.72,2.72,0,0,1-.46-2.21,2.15,2.15,0,0,1,.81-1.21,2.78,2.78,0,0,1,1.54-.51,3.34,3.34,0,0,1,1.74.44,3.28,3.28,0,0,1,1.33,1.4,5.72,5.72,0,0,1,.31,4.17,12,12,0,0,1-2.3,4,30.64,30.64,0,0,0-3,3.94,8.45,8.45,0,0,0-1.12,4.66,8,8,0,0,0,.45,2.25,3.67,3.67,0,0,0,1.25,1.72,1.88,1.88,0,0,0,1.9.11,3.79,3.79,0,0,0,1.82-4.62,2.28,2.28,0,0,0-1-1.08,1.7,1.7,0,0,0-2.18.66,1.37,1.37,0,0,0-.16,1,1.57,1.57,0,0,0,.78,1.1A1.53,1.53,0,0,0,113.86,132.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,138.18a1,1,0,1,1-1-1A1,1,0,0,1,114.43,138.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.86,
    cy: 111.16,
    r: 1.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.42,77.92a1.93,1.93,0,0,0,.47-.14,1.53,1.53,0,0,0,.77-1.1,1.37,1.37,0,0,0-.15-1,1.59,1.59,0,0,0-.89-.72,1.64,1.64,0,0,0-1.3.06,2.28,2.28,0,0,0-1,1.08,3.84,3.84,0,0,0,1.83,4.64,1.86,1.86,0,0,0,1.9-.12,3.65,3.65,0,0,0,1.25-1.73,7.62,7.62,0,0,0,.44-2.25A8.41,8.41,0,0,0,115.61,72a31.71,31.71,0,0,0-3-4,12.06,12.06,0,0,1-2.3-4,5.8,5.8,0,0,1,.3-4.18A3.36,3.36,0,0,1,113.73,58a2.72,2.72,0,0,1,1.55.52,2.2,2.2,0,0,1,.81,1.2,2.77,2.77,0,0,1-.46,2.22,1.76,1.76,0,0,1-1.18.8.94.94,0,0,1-.38,0l-.13,0h.13a1.23,1.23,0,0,0,.36,0,1.8,1.8,0,0,0,1.1-.81,2.66,2.66,0,0,0,.38-2.1,1.92,1.92,0,0,0-.76-1.08,2.51,2.51,0,0,0-1.42-.46A3.14,3.14,0,0,0,110.9,60a5.54,5.54,0,0,0-.25,4,11.75,11.75,0,0,0,2.26,3.92,31.92,31.92,0,0,1,3,4A8.73,8.73,0,0,1,117,76.7a8,8,0,0,1-.47,2.35,3.92,3.92,0,0,1-1.37,1.87,2.19,2.19,0,0,1-1.1.37,2.35,2.35,0,0,1-1.09-.24,3.8,3.8,0,0,1-1.53-1.41,3.75,3.75,0,0,1-.39-3.59,2.49,2.49,0,0,1,1.14-1.17,1.91,1.91,0,0,1,1.46,0,1.88,1.88,0,0,1,1,.83,1.53,1.53,0,0,1,.14,1,1.59,1.59,0,0,1-.87,1.13A.85.85,0,0,1,113.42,77.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.73,89.72a1.6,1.6,0,0,0-.47.13,1.53,1.53,0,0,0-.77,1.1,1.39,1.39,0,0,0,.15,1,1.63,1.63,0,0,0,.89.72,1.64,1.64,0,0,0,1.3-.06,2.28,2.28,0,0,0,1-1.08A3.84,3.84,0,0,0,114,86.85a1.86,1.86,0,0,0-1.9.12,3.54,3.54,0,0,0-1.25,1.73,7.56,7.56,0,0,0-.44,2.25,8.41,8.41,0,0,0,1.11,4.67,31.71,31.71,0,0,0,2.95,3.95,12,12,0,0,1,2.3,4,5.8,5.8,0,0,1-.3,4.18,3.3,3.3,0,0,1-1.34,1.4,3.44,3.44,0,0,1-1.73.45,2.72,2.72,0,0,1-1.55-.52,2.2,2.2,0,0,1-.81-1.21,2.79,2.79,0,0,1,.46-2.22,1.78,1.78,0,0,1,1.18-.79,1.25,1.25,0,0,1,.38,0c.08,0,.13,0,.13,0h-.13a1,1,0,0,0-.37,0,1.81,1.81,0,0,0-1.09.81,2.66,2.66,0,0,0-.38,2.1A1.92,1.92,0,0,0,112,109a2.43,2.43,0,0,0,1.42.45,3.13,3.13,0,0,0,2.83-1.74,5.54,5.54,0,0,0,.25-4,11.92,11.92,0,0,0-2.26-3.92,31.92,31.92,0,0,1-3-4,8.76,8.76,0,0,1-1.14-4.85,8.11,8.11,0,0,1,.47-2.35A4,4,0,0,1,112,86.71a2.28,2.28,0,0,1,1.1-.36,2.35,2.35,0,0,1,1.09.24A3.8,3.8,0,0,1,115.67,88a3.75,3.75,0,0,1,.39,3.59,2.54,2.54,0,0,1-1.14,1.17,1.86,1.86,0,0,1-1.46,0,1.82,1.82,0,0,1-1-.82,1.53,1.53,0,0,1-.14-1,1.62,1.62,0,0,1,.87-1.14A.88.88,0,0,1,113.73,89.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.86,
    cy: 84.05,
    r: 1.01,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,168.26a1.93,1.93,0,0,0-.14-.47,1.53,1.53,0,0,0-1.1-.77,1.36,1.36,0,0,0-1,.15,1.68,1.68,0,0,0-.73.89,1.65,1.65,0,0,0,.07,1.3,2.24,2.24,0,0,0,1.08,1,3.85,3.85,0,0,0,4.64-1.82,1.87,1.87,0,0,0-.12-1.91A3.57,3.57,0,0,0,66,165.41a7.63,7.63,0,0,0-2.25-.45A8.47,8.47,0,0,0,59,166.07a32,32,0,0,0-3.95,3,11.89,11.89,0,0,1-4,2.3,5.74,5.74,0,0,1-4.18-.3,3.36,3.36,0,0,1-1.41-1.33A3.44,3.44,0,0,1,45,168a2.66,2.66,0,0,1,.52-1.54,2.1,2.1,0,0,1,1.2-.81,2.73,2.73,0,0,1,2.22.45,1.76,1.76,0,0,1,.8,1.19.9.9,0,0,1,0,.37,1.11,1.11,0,0,1,0,.13s0-.05,0-.13a1.77,1.77,0,0,0,0-.36,1.8,1.8,0,0,0-.81-1.1,2.7,2.7,0,0,0-2.1-.38,2,2,0,0,0-1.09.76,2.53,2.53,0,0,0-.45,1.43A3.12,3.12,0,0,0,47,170.78a5.44,5.44,0,0,0,4,.25,11.58,11.58,0,0,0,3.92-2.26,30.91,30.91,0,0,1,4-3,8.74,8.74,0,0,1,4.84-1.15,8,8,0,0,1,2.35.47,3.87,3.87,0,0,1,1.87,1.38,2.16,2.16,0,0,1,.37,1.09,2.4,2.4,0,0,1-.24,1.1,3.84,3.84,0,0,1-1.41,1.52,3.72,3.72,0,0,1-3.59.39,2.49,2.49,0,0,1-1.17-1.14,1.88,1.88,0,0,1,0-1.45,1.73,1.73,0,0,1,.83-1,1.48,1.48,0,0,1,1-.15,1.62,1.62,0,0,1,1.13.87A.85.85,0,0,1,64.94,168.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,168a.82.82,0,0,1-.08.49,1.57,1.57,0,0,1-1.13.87,1.55,1.55,0,0,1-1.06-.14,1.79,1.79,0,0,1-.82-1,1.84,1.84,0,0,1,0-1.45,2.4,2.4,0,0,1,1.17-1.14A3.7,3.7,0,0,1,95,166a3.76,3.76,0,0,1,1.42,1.53,2.25,2.25,0,0,1,.23,1.09,2.18,2.18,0,0,1-.36,1.1,3.84,3.84,0,0,1-1.87,1.37,8,8,0,0,1-2.35.48,8.79,8.79,0,0,1-4.85-1.15,30.85,30.85,0,0,1-4-3,12,12,0,0,0-3.93-2.26,5.49,5.49,0,0,0-4,.26,3.12,3.12,0,0,0-1.74,2.82,2.56,2.56,0,0,0,.45,1.43,2,2,0,0,0,1.09.75,2.62,2.62,0,0,0,2.1-.38,1.75,1.75,0,0,0,.8-1.09,1.41,1.41,0,0,0,0-.37c0-.08,0-.12,0-.12a1.13,1.13,0,0,1,0,.12,1,1,0,0,1,0,.38,1.84,1.84,0,0,1-.8,1.19,2.78,2.78,0,0,1-2.22.45,2.1,2.1,0,0,1-1.2-.81,2.71,2.71,0,0,1-.52-1.54,3.44,3.44,0,0,1,.44-1.74,3.38,3.38,0,0,1,1.41-1.34,5.79,5.79,0,0,1,4.18-.3,12.15,12.15,0,0,1,4,2.3,30.64,30.64,0,0,0,3.94,2.95,8.5,8.5,0,0,0,4.67,1.12,8,8,0,0,0,2.26-.45,3.57,3.57,0,0,0,1.73-1.25,1.9,1.9,0,0,0,.12-1.9,3.5,3.5,0,0,0-1.3-1.42,3.46,3.46,0,0,0-3.34-.4,2.2,2.2,0,0,0-1.08,1,1.64,1.64,0,0,0-.07,1.3,1.62,1.62,0,0,0,.73.88,1.37,1.37,0,0,0,1,.16,1.59,1.59,0,0,0,1.1-.77A3.09,3.09,0,0,0,93.32,168Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,166.81a1,1,0,1,0,1,1A1,1,0,0,0,71.07,166.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,166.81a1,1,0,1,0,0,2,1,1,0,0,0,0-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.52,
    cy: 167.83,
    r: 1.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.94,53.69a2.08,2.08,0,0,0-.14-.47,1.56,1.56,0,0,0-1.1-.77,1.31,1.31,0,0,0-1,.16,1.62,1.62,0,0,0-.73.88,1.64,1.64,0,0,0,.07,1.3,2.24,2.24,0,0,0,1.08,1A3.82,3.82,0,0,0,67.81,54a1.88,1.88,0,0,0-.12-1.91A3.57,3.57,0,0,0,66,50.84a7.63,7.63,0,0,0-2.25-.45A8.48,8.48,0,0,0,59,51.51a30.07,30.07,0,0,0-3.95,3,12.06,12.06,0,0,1-4,2.3,5.74,5.74,0,0,1-4.18-.31,3.3,3.3,0,0,1-1.41-1.33A3.44,3.44,0,0,1,45,53.38a2.71,2.71,0,0,1,.52-1.54,2.1,2.1,0,0,1,1.2-.81,2.77,2.77,0,0,1,2.22.45,1.76,1.76,0,0,1,.8,1.19,1,1,0,0,1,0,.38,1.13,1.13,0,0,1,0,.12s0,0,0-.13a1.82,1.82,0,0,0,0-.36,1.79,1.79,0,0,0-.81-1.09,2.62,2.62,0,0,0-2.1-.38A2,2,0,0,0,45.7,52a2.53,2.53,0,0,0-.45,1.43A3.11,3.11,0,0,0,47,56.21a5.49,5.49,0,0,0,4,.26,11.92,11.92,0,0,0,3.92-2.26,31,31,0,0,1,4-3,8.74,8.74,0,0,1,4.84-1.15,7.68,7.68,0,0,1,2.35.48,3.79,3.79,0,0,1,1.87,1.37,2.19,2.19,0,0,1,.37,1.1,2.38,2.38,0,0,1-.24,1.09,3.8,3.8,0,0,1-1.41,1.53,3.72,3.72,0,0,1-3.59.38,2.45,2.45,0,0,1-1.17-1.14,1.88,1.88,0,0,1,0-1.45,1.73,1.73,0,0,1,.83-1,1.42,1.42,0,0,1,1-.14,1.59,1.59,0,0,1,1.13.86A.85.85,0,0,1,64.94,53.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.32,53.39a.85.85,0,0,1-.08.5,1.59,1.59,0,0,1-1.13.86,1.45,1.45,0,0,1-1.06-.14,1.75,1.75,0,0,1-.82-1,1.84,1.84,0,0,1,0-1.45,2.49,2.49,0,0,1,1.17-1.14,3.72,3.72,0,0,1,3.58.38A3.89,3.89,0,0,1,96.45,53a2.27,2.27,0,0,1,.23,1.1,2.17,2.17,0,0,1-.36,1.09,3.84,3.84,0,0,1-1.87,1.37A7.68,7.68,0,0,1,92.1,57a8.79,8.79,0,0,1-4.85-1.15,30.8,30.8,0,0,1-4-3,11.62,11.62,0,0,0-3.93-2.26,5.44,5.44,0,0,0-4,.25,3.13,3.13,0,0,0-1.74,2.82,2.53,2.53,0,0,0,.45,1.43,2,2,0,0,0,1.09.76,2.7,2.7,0,0,0,2.1-.38,1.74,1.74,0,0,0,.8-1.1,1.38,1.38,0,0,0,0-.36c0-.09,0-.13,0-.13a1.11,1.11,0,0,1,0,.13.9.9,0,0,1,0,.37,1.79,1.79,0,0,1-.8,1.19,2.78,2.78,0,0,1-2.22.45,2.1,2.1,0,0,1-1.2-.81,2.71,2.71,0,0,1-.52-1.54A3.44,3.44,0,0,1,73.84,52a3.3,3.3,0,0,1,1.41-1.33,5.69,5.69,0,0,1,4.18-.3,12,12,0,0,1,4,2.3,32.61,32.61,0,0,0,3.94,2.95,8.49,8.49,0,0,0,4.67,1.11,7.69,7.69,0,0,0,2.26-.45A3.62,3.62,0,0,0,96.07,55a1.92,1.92,0,0,0,.12-1.91,3.56,3.56,0,0,0-1.3-1.42,3.49,3.49,0,0,0-3.34-.4,2.24,2.24,0,0,0-1.08,1,1.64,1.64,0,0,0-.07,1.3,1.68,1.68,0,0,0,.73.89,1.36,1.36,0,0,0,1,.15,1.53,1.53,0,0,0,1.1-.77A2.76,2.76,0,0,0,93.32,53.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.07,52.24a1,1,0,1,0,1,1A1,1,0,0,0,71.07,52.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.22,52.24a1,1,0,1,0,0,2,1,1,0,0,0,0-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.52,
    cy: 53.26,
    r: 1.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.3,161.4s0-.17,0-.49,0-.8,0-1.42c0-1.26,0-3.11,0-5.52,0-4.82,0-11.85,0-20.76,0-17.78,0-43-.07-72.83l.15.15-70.91,0h0l.16-.17c0,37.89,0,72.91,0,101l-.13-.14,51.59.07,14.28,0H106l1.3,0H106l-3.72,0-14.26,0-51.67.07h-.13v-.13c0-28.11,0-63.13,0-101v-.16h71.23v.15c0,29.85-.06,55.12-.08,72.93,0,8.89,0,15.91,0,20.73,0,2.39,0,4.23,0,5.48v1.41C107.3,161.24,107.3,161.4,107.3,161.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,46.22a22.73,22.73,0,0,0-2.6,1.44,28.54,28.54,0,0,0-5.23,4.91c-1.85,2.12-3.38,4.17-4.55,5.6-.59.72-1.08,1.29-1.44,1.67a3.62,3.62,0,0,1-.59.54,3.61,3.61,0,0,1,.5-.63c.32-.4.79-1,1.34-1.72,1.13-1.47,2.63-3.54,4.5-5.68A26.05,26.05,0,0,1,119,47.47a8.57,8.57,0,0,1,1.09-.63l.46-.23.41-.15A3.48,3.48,0,0,1,121.71,46.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.05,176.08a4.74,4.74,0,0,1-.55-.61l-1.43-1.69c-1.21-1.42-2.93-3.35-4.94-5.36s-3.95-3.73-5.38-4.93l-1.7-1.42a3.54,3.54,0,0,1-.6-.55,3.89,3.89,0,0,1,.68.45c.43.3,1,.76,1.77,1.34a67.73,67.73,0,0,1,5.46,4.88,68.53,68.53,0,0,1,4.89,5.44c.59.73,1,1.34,1.35,1.77A3.17,3.17,0,0,1,122.05,176.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.72,175.89a3.53,3.53,0,0,1,.4-.7c.28-.45.7-1.07,1.25-1.82a44.52,44.52,0,0,1,10.39-10.11c.76-.53,1.4-.94,1.85-1.2a3.82,3.82,0,0,1,.71-.38,4.3,4.3,0,0,1-.64.49c-.43.29-1,.73-1.79,1.28a53.13,53.13,0,0,0-10.33,10.06c-.57.73-1,1.33-1.33,1.75A3.75,3.75,0,0,1,21.72,175.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,46.22a3.78,3.78,0,0,1,.59.53l1.56,1.51c1.32,1.27,3.17,3,5.23,4.88s3.9,3.64,5.17,5c.64.65,1.15,1.19,1.49,1.58a4,4,0,0,1,.51.62,4.39,4.39,0,0,1-.6-.53l-1.56-1.51c-1.32-1.27-3.17-3-5.23-4.88s-3.89-3.64-5.17-5c-.64-.66-1.15-1.2-1.49-1.58A3.86,3.86,0,0,1,22,46.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,49.2c.09,0,.16,27.42.16,61.24s-.07,61.24-.16,61.24-.17-27.41-.17-61.24S117.7,49.2,117.79,49.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,48.92c0,.09-20.48.16-45.72.16S24.94,49,24.94,48.92s20.46-.17,45.72-.17S116.38,48.83,116.38,48.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.22,169.71c-.09,0-.16-27-.16-60.25s.07-60.26.16-60.26.16,27,.16,60.26S25.31,169.71,25.22,169.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,172c0,.09-20.22.17-45.16.17s-45.15-.08-45.15-.17,20.21-.16,45.15-.16S117.79,171.87,117.79,172Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.09,163.62s0-.17,0-.51,0-.84,0-1.49c0-1.31,0-3.25,0-5.77,0-5,0-12.41-.06-21.74,0-18.63-.08-45.09-.13-76.4l.14.15-76.71-.27.17-.17v.12c.11,39.77.22,76.57.31,106.29l-.13-.13,55.59-.09h20.86l-1.37,0-4,0-15.39.08L33.64,164H33.5v-.14c-.1-29.72-.23-66.52-.37-106.29v-.28h.16l76.71.31h.15v.14c0,31.35,0,57.84,0,76.5,0,9.31,0,16.67,0,21.7,0,2.51,0,4.44,0,5.75,0,.64,0,1.13,0,1.47S110.09,163.62,110.09,163.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.35,63.62a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,63.62Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.63,163.82c-.1,0-.19-.54-.17-1.19s.08-1.17.17-1.18.19.54.16,1.19A3,3,0,0,1,39.63,163.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.14,163.85c-.1,0-.19-.53-.17-1.19s.08-1.16.17-1.17.19.53.16,1.18A3,3,0,0,1,37.14,163.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.45,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S42.54,163.71,42.45,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,163.71c-.09,0-.19-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S45.13,163.71,45,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.62,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.21,1.14S47.71,163.71,47.62,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.21,163.71c-.09,0-.18-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S50.3,163.71,50.21,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.79,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.19.51.21,1.14S52.88,163.71,52.79,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.38,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S55.47,163.71,55.38,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,163.71c-.1,0-.19-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S58.06,163.71,58,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.55,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S60.64,163.71,60.55,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.14,163.71c-.09,0-.18-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S63.23,163.71,63.14,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.72,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.21,1.14S65.81,163.71,65.72,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.31,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S68.4,163.71,68.31,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.89,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.19.51.21,1.14S71,163.71,70.89,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.48,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S73.57,163.71,73.48,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07,163.71c-.09,0-.19-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S76.16,163.71,76.07,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.65,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.21,1.14S78.74,163.71,78.65,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.24,163.71c-.09,0-.18-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S81.33,163.71,81.24,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.82,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.21,1.14S83.91,163.71,83.82,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.41,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S86.5,163.71,86.41,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.13-1.15.18.51.2,1.14S89.09,163.71,89,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S91.67,163.71,91.58,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.17,163.71c-.09,0-.19-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S94.26,163.71,94.17,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.75,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.21,1.14S96.84,163.71,96.75,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.34,163.71c-.09,0-.18-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S99.43,163.71,99.34,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.92,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.19.51.21,1.14S102,163.71,101.92,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.51,163.71c-.09,0-.18-.5-.2-1.13s0-1.14.12-1.15.18.51.2,1.14S104.6,163.71,104.51,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1,163.71c-.1,0-.19-.5-.21-1.13s0-1.14.13-1.15.18.51.2,1.14S107.19,163.71,107.1,163.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,160.71a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,160.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,157.83a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,157.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,155a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,155Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,152.08a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,152.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,149.2a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,149.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,146.32a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,146.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,143.44a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,143.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,140.56a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,140.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,137.68a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,137.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,134.81a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,134.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,131.93a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,131.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,129.05a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,129.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,126.17a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,126.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,123.29a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,123.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,120.41a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,120.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,117.54a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16c0-.1.62-.17,1.37-.17S110,117.44,110,117.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,114.66a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,114.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,111.78a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,111.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,108.9a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,108.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,106a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,106Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,103.14a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,103.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,100.26c0,.1-.61.17-1.36.17s-1.37-.07-1.37-.17a3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,100.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,97.39a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,97.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,94.51a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,94.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,91.63a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,91.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,88.75a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,88.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,85.87a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,85.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,83a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,80.12a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,80.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,77.24a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,77.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,74.36a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,74.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,71.48a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,71.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,68.6a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,68.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,65.72a2.93,2.93,0,0,1-1.36.17,3,3,0,0,1-1.37-.17,3.07,3.07,0,0,1,1.37-.16A3,3,0,0,1,110,65.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,62.85a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,62.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110,60a3,3,0,0,1-1.36.16,3.07,3.07,0,0,1-1.37-.16,3,3,0,0,1,1.37-.17A2.93,2.93,0,0,1,110,60Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,60.38a2.87,2.87,0,0,1-.17-1.35,2.9,2.9,0,0,1,.17-1.35,3,3,0,0,1,.16,1.35A3,3,0,0,1,106.89,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.14,60.38A3,3,0,0,1,104,59a3,3,0,0,1,.16-1.35c.1,0,.17.61.17,1.35S104.24,60.38,104.14,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,60.38a3,3,0,0,1-.16-1.35,3,3,0,0,1,.16-1.35,2.9,2.9,0,0,1,.17,1.35A2.87,2.87,0,0,1,101.4,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.66,60.38A3,3,0,0,1,98.5,59a3,3,0,0,1,.16-1.35A3,3,0,0,1,98.82,59,3,3,0,0,1,98.66,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.92,60.38A2.87,2.87,0,0,1,95.75,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,96.08,59,3,3,0,0,1,95.92,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.18,60.38A2.87,2.87,0,0,1,93,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,93.34,59,3,3,0,0,1,93.18,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.43,60.38A3,3,0,0,1,90.27,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,90.6,59,2.87,2.87,0,0,1,90.43,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.69,60.38A3,3,0,0,1,87.53,59a3,3,0,0,1,.16-1.35A3,3,0,0,1,87.85,59,3,3,0,0,1,87.69,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,60.38A3,3,0,0,1,84.79,59,3,3,0,0,1,85,57.68,3,3,0,0,1,85.11,59,3,3,0,0,1,85,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.21,60.38A2.87,2.87,0,0,1,82,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,82.37,59,3,3,0,0,1,82.21,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.46,60.38A3,3,0,0,1,79.3,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,79.63,59,2.87,2.87,0,0,1,79.46,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.72,60.38A3,3,0,0,1,76.56,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,76.89,59,2.87,2.87,0,0,1,76.72,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74,60.38A3,3,0,0,1,73.82,59,3,3,0,0,1,74,57.68,3,3,0,0,1,74.14,59,3,3,0,0,1,74,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,60.38A2.87,2.87,0,0,1,71.07,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,71.4,59,3,3,0,0,1,71.24,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5,60.38c-.1,0-.17-.6-.17-1.35s.07-1.35.17-1.35A3,3,0,0,1,68.66,59,3,3,0,0,1,68.5,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.75,60.38A3,3,0,0,1,65.59,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,65.92,59,2.87,2.87,0,0,1,65.75,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,60.38A3,3,0,0,1,62.85,59,3,3,0,0,1,63,57.68,3,3,0,0,1,63.17,59,3,3,0,0,1,63,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.27,60.38A2.87,2.87,0,0,1,60.1,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,60.43,59,3,3,0,0,1,60.27,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.53,60.38A2.87,2.87,0,0,1,57.36,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,57.69,59,3,3,0,0,1,57.53,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.78,60.38A3,3,0,0,1,54.62,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,55,59,2.87,2.87,0,0,1,54.78,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,60.38A3,3,0,0,1,51.88,59,3,3,0,0,1,52,57.68,2.9,2.9,0,0,1,52.21,59,2.87,2.87,0,0,1,52,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3,60.38A3,3,0,0,1,49.14,59a3,3,0,0,1,.16-1.35A3,3,0,0,1,49.46,59,3,3,0,0,1,49.3,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.56,60.38A2.87,2.87,0,0,1,46.39,59a2.9,2.9,0,0,1,.17-1.35A3,3,0,0,1,46.72,59,3,3,0,0,1,46.56,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.81,60.38A3,3,0,0,1,43.65,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,44,59,2.87,2.87,0,0,1,43.81,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.07,60.38A3,3,0,0,1,40.91,59a3,3,0,0,1,.16-1.35A2.9,2.9,0,0,1,41.24,59,2.87,2.87,0,0,1,41.07,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.33,60.38A3,3,0,0,1,38.17,59a3,3,0,0,1,.16-1.35A3,3,0,0,1,38.49,59,3,3,0,0,1,38.33,60.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,61.32a3.55,3.55,0,0,1-1.55.17,3.55,3.55,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,61.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,65.91a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,65.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,68.2a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17A3.84,3.84,0,0,1,34.8,68,3.84,3.84,0,0,1,36.35,68.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,70.5a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,70.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,72.79A3.84,3.84,0,0,1,34.8,73a3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,72.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,75.08a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,75.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,77.37a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,77.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,79.67a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,79.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,82a3.84,3.84,0,0,1-1.55.16A3.84,3.84,0,0,1,33.25,82a3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,84.25a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,84.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,86.54a3.55,3.55,0,0,1-1.55.17,3.55,3.55,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,86.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,88.84A3.84,3.84,0,0,1,34.8,89a3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,88.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,91.13a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16A3.84,3.84,0,0,1,34.8,91,3.84,3.84,0,0,1,36.35,91.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,93.42a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,93.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,95.72a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,95.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,98a3.84,3.84,0,0,1-1.55.16A3.84,3.84,0,0,1,33.25,98a3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,98Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,100.3a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,100.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,102.59a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,102.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,104.89a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,104.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,107.18a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16A3.84,3.84,0,0,1,34.8,107,3.84,3.84,0,0,1,36.35,107.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,109.47a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,109.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,111.76a3.55,3.55,0,0,1-1.55.17,3.55,3.55,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,111.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,114.06a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,114.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,116.35a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,116.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,118.64a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,118.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,120.94a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,120.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,123.23a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,123.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,125.52a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,125.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,127.81a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,127.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,130.11a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,130.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,132.4a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,132.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,134.69a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,134.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,137a3.55,3.55,0,0,1-1.55.17,3.55,3.55,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,137Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,139.28a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,139.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,141.57a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,141.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,143.86a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,143.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,146.16a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16A3.74,3.74,0,0,1,34.8,146,3.74,3.74,0,0,1,36.35,146.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,148.45a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,148.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,150.74a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,150.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,153a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,153Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,155.33a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.74,3.74,0,0,1,1.55-.17A3.74,3.74,0,0,1,36.35,155.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,157.62a3.84,3.84,0,0,1-1.55.16,3.84,3.84,0,0,1-1.55-.16,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,157.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.35,159.91a3.74,3.74,0,0,1-1.55.17,3.74,3.74,0,0,1-1.55-.17,3.84,3.84,0,0,1,1.55-.16A3.84,3.84,0,0,1,36.35,159.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.45,
    y: 60.39,
    width: 70.44,
    height: 101.07,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,71.72c12,14.23,26,29.17,37.5,43.79l-37.45,10Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.41,123.83l0,37.62,70.84-.54L107,108.57q-35.4,7.17-70.61,15.26",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.23,
    y: 25.77,
    width: 70.82,
    height: 73.83,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.43,
    y: 25.77,
    width: 70.82,
    height: 73.83,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.28,99.62H155.41V25.75h70.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.95,
    y: 35.69,
    width: 51.78,
    height: 53.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,90a8.58,8.58,0,0,1-1.28,1.49c-.83.87-2,2-3.29,3.33s-2.5,2.43-3.38,3.24a8.76,8.76,0,0,1-1.5,1.25,8,8,0,0,1,1.27-1.48c.83-.87,2-2.06,3.3-3.34s2.51-2.44,3.39-3.25A8,8,0,0,1,165,90Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,89.9a8.17,8.17,0,0,1,1.49,1.28c.87.82,2.05,2,3.34,3.29s2.42,2.5,3.23,3.38a7.36,7.36,0,0,1,1.25,1.5,9,9,0,0,1-1.48-1.27c-.87-.83-2.06-2-3.34-3.3s-2.44-2.51-3.25-3.39A8,8,0,0,1,216.73,89.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,35.84a8.17,8.17,0,0,1,1.28-1.49c.83-.87,2-2.05,3.29-3.34s2.5-2.42,3.38-3.23a8.06,8.06,0,0,1,1.5-1.25A7.86,7.86,0,0,1,224.77,28c-.83.87-2,2.06-3.3,3.34s-2.51,2.43-3.39,3.25A8.54,8.54,0,0,1,216.59,35.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,36a8.58,8.58,0,0,1-1.49-1.28c-.87-.83-2-2-3.33-3.29s-2.43-2.5-3.24-3.38a9.24,9.24,0,0,1-1.25-1.5A8,8,0,0,1,157,27.79c.87.83,2.06,2,3.34,3.3s2.44,2.51,3.25,3.39A8,8,0,0,1,164.81,36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.59,89.67s0-.09,0-.26,0-.43,0-.75c0-.68,0-1.65,0-2.92,0-2.55,0-6.27-.06-11,0-9.45-.06-22.92-.1-39l.2.2-51.64,0h0l.23-.23c0,19.82,0,38.35,0,54l-.2-.19,37.39.1,10.5,0,2.78,0h1s-.07,0-.23,0h-.69l-2.74,0-10.46,0-37.52.1h-.2v-.2c0-15.63,0-34.16,0-54v-.23H165l51.64,0h.2v.2c0,16.18-.08,29.69-.1,39.18,0,4.7,0,8.41-.05,11,0,1.24,0,2.2,0,2.87,0,.31,0,.55,0,.73A.82.82,0,0,1,216.59,89.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.29,77.31a11.47,11.47,0,0,1-.51-15.07c1.44-1.65,3.36-2.85,4.69-4.59,2.89-3.77,2.85-9.7,6.86-12.22,2.94-1.84,7.14-.79,9.28,1.93a9.82,9.82,0,0,1,.93,9.84c-1,2.34-2.81,4.33-3.54,6.78s-.32,5.25-1.1,7.74c-.93,3-4.12,4.92-7.08,6a13.26,13.26,0,0,1-9.53-.42",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,52.44a9.11,9.11,0,0,1-.5,1.43c-.35.91-.89,2.21-1.61,3.79a104.06,104.06,0,0,1-6.4,12,106,106,0,0,1-7.89,11.07c-1.1,1.34-2,2.41-2.68,3.12a9.27,9.27,0,0,1-1.06,1.09,10,10,0,0,1,.92-1.21c.62-.75,1.5-1.84,2.56-3.21A128.33,128.33,0,0,0,187,69.41a128.59,128.59,0,0,0,6.49-11.88c.75-1.57,1.34-2.84,1.74-3.73A9.67,9.67,0,0,1,195.86,52.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.15,61.8a17,17,0,0,1,.41,2.73c.21,1.7.46,4.08.72,6.76l-.34-.18,1.11-.65c2.59-1.51,4.95-2.86,6.66-3.81a23.39,23.39,0,0,1,2.83-1.46,21.52,21.52,0,0,1-2.66,1.75c-1.67,1-4,2.41-6.59,3.92l-1.12.65-.31.18,0-.36c-.25-2.68-.44-5.06-.57-6.77A16.91,16.91,0,0,1,185.15,61.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.75,57.8a8.19,8.19,0,0,1-1.75,1c-1.1.55-2.64,1.28-4.34,2.06l-.54.25-.28.12,0-.3c-.27-1.72-.49-3.26-.63-4.37a7.87,7.87,0,0,1-.13-1.81,7,7,0,0,1,.44,1.76c.22,1.09.49,2.63.78,4.35l-.33-.18.53-.24c1.71-.78,3.27-1.46,4.41-1.94A9.48,9.48,0,0,1,198.75,57.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.47,
    y: 424.43,
    width: 10.33,
    height: 48.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.27,
    y: 424.43,
    width: 10.33,
    height: 48.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.37,
    y: 363.12,
    width: 130.36,
    height: 12.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.54 425.04 296.31 425.3 296.31 375.18 413.54 375.18 413.54 425.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.73,375.18c0,.13-29.18.24-65.17.24s-65.19-.11-65.19-.24,29.18-.23,65.19-.23S418.73,375.05,418.73,375.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.11,425.3c0,.13-26.06.23-58.18.23s-58.19-.1-58.19-.23,26-.24,58.19-.24S413.11,425.17,413.11,425.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,415.14s0-.2,0-.57,0-.95,0-1.67c0-1.47,0-3.62,0-6.41,0-5.58-.05-13.69-.08-23.87l.15.16-97.89.08h0l.24-.24c0,11.3,0,22.26,0,32.52l-.23-.23,70,.11,20.46.06,5.5,0,1.43,0h.49l-.46,0H402l-5.45,0-20.41.06-70.18.11h-.22v-.23c0-10.26,0-21.22,0-32.52v-.23H306l97.89.08H404v.15c0,10.22-.07,18.36-.09,24,0,2.77,0,4.91,0,6.38,0,.71,0,1.25,0,1.64S403.87,415.14,403.87,415.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,410.88a8.14,8.14,0,0,1-1.7,2.16,8.05,8.05,0,0,1-2,1.85,8.44,8.44,0,0,1,1.7-2.17A8.07,8.07,0,0,1,309.85,410.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.85,386.89a9.23,9.23,0,0,1-2.11-2,8.85,8.85,0,0,1-1.76-2.29,9,9,0,0,1,2.11,2A8.85,8.85,0,0,1,309.85,386.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.05,382.72a8.43,8.43,0,0,1-2.14,2.26,13.05,13.05,0,0,1-2.44,1.91,8.43,8.43,0,0,1,2.14-2.26A13.05,13.05,0,0,1,404.05,382.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.87,415.14a10,10,0,0,1-2.36-2,10.36,10.36,0,0,1-2-2.3,10.62,10.62,0,0,1,2.36,2A10.36,10.36,0,0,1,403.87,415.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.47,410.88s0-.15,0-.43,0-.69,0-1.21c0-1.09,0-2.66,0-4.71,0-4.11-.05-10.09-.08-17.64l.14.14-89.61.09h0l.24-.23c0,8.24,0,16.28,0,24l-.23-.23,63.95.1,18.82.07,5.08,0H399l.45,0H399l-1.29,0-5,0L374,411l-64.11.11h-.23V386.65h.24l89.61.09h.15v.15c0,7.59-.06,13.6-.08,17.72,0,2,0,3.6,0,4.68,0,.51,0,.91,0,1.19S399.47,410.88,399.47,410.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.54,396.65a9.16,9.16,0,0,0-2.4-1.1,7.69,7.69,0,0,0-2.38-.37h-6.6a7.58,7.58,0,0,0-5.25,2,4.46,4.46,0,0,0-.79,1,2.69,2.69,0,0,0,.26,3.22c.84.79,2.58.41,2.72-.75a2.87,2.87,0,0,0,3,2.7,3.85,3.85,0,0,0,3.24-2.81,2.58,2.58,0,0,0,5.13.39c.81,1.06,2,2.05,3.4,1.6a2.46,2.46,0,0,0,1.58-1.77A3.93,3.93,0,0,0,363.54,396.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.34,395.15a13.06,13.06,0,0,0-2.71,2.48A13.42,13.42,0,0,0,349.1,401c-.06,0-.1-.43,0-1.12a6.32,6.32,0,0,1,1.11-2.49,6.53,6.53,0,0,1,2-1.83C352.89,395.19,353.32,395.1,353.34,395.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,395.43a14.83,14.83,0,0,1-.54,5.19,7.44,7.44,0,0,1,0-2.62A7.67,7.67,0,0,1,355.86,395.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,395.35c0-.05.38.09.77.52a4.22,4.22,0,0,1,.93,2,7.34,7.34,0,0,1,0,2.2c-.08.56-.17.89-.23.89s-.09-.35-.1-.9a14.14,14.14,0,0,0-.14-2.1,5.11,5.11,0,0,0-.73-1.91C359.26,395.63,359,395.41,359,395.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.66,
    y: 440.85,
    width: 80.33,
    height: 9.41,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.79,350.91V363h-52.1a6.05,6.05,0,0,1-6.05-6.06h0a6.06,6.06,0,0,1,6.05-6.06",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17,353.45h17.62a0,0,0,0,1,0,0v7a0,0,0,0,1,0,0H357.17a3.05,3.05,0,0,1-3.05-3.05v-.93A3.05,3.05,0,0,1,357.17,353.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.79,338.8v12.11h-52.1a6.05,6.05,0,0,1-6.05-6.05h0a6.05,6.05,0,0,1,6.05-6.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17,341.34h17.62a0,0,0,0,1,0,0v7a0,0,0,0,1,0,0H357.17a3.05,3.05,0,0,1-3.05-3.05v-.93A3.05,3.05,0,0,1,357.17,341.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.17 319.36 328.89 338.8 334.22 338.8 337.89 328.42 337.17 319.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.57 301.78 365.77 338.8 338.73 338.8 335.76 301.78 362.57 301.78",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.93 304.71 362.73 335.72 342.43 335.99 339.69 304.53 359.93 304.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.62 309.01 357.22 330.35 346.39 330.35 344.48 309.01 355.62 309.01",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461,473.74c0,.14-94,.26-210,.26s-210-.12-210-.26,94-.26,210-.26S461,473.59,461,473.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M458.84,247C447,253.08,438,263.62,431.45,275.22s-10.71,24.34-14.87,37l-3.64,65.19c13.75-23.39,24.78-50.88,27.76-77.85l-9.14-.82c6.13-.93,11.28-5.38,14.56-10.65s5-11.35,6.6-17.33l-11.16,1.66A41.39,41.39,0,0,0,458.84,247Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M458.84,247C447,253.08,438,263.62,431.45,275.22s-10.71,24.34-14.87,37l-3.64,65.19c13.75-23.39,24.78-50.88,27.76-77.85l-9.14-.82c6.13-.93,11.28-5.38,14.56-10.65s5-11.35,6.6-17.33l-11.16,1.66A41.39,41.39,0,0,0,458.84,247Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M410.9,392.67S381.06,357,381.4,322.85h12.06s-13.1-8.61-12.06-13.43,1.38-23.08,1.38-23.08l11,2.75s-8.26-4.13-9.3-10.67,2.41-36.86,2.41-36.86,13.44,14.12,17.57,28.59,15,31.34,11.8,75.43S410.9,392.67,410.9,392.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,396s32.33-21.54,39.52-49l-9.69-2.64s12.41-4.05,12.63-8.16,3.94-18.85,3.94-18.85l-9.47-.2s7.56-1.51,9.82-6.55,6.12-30.16,6.12-30.16-13.89,8.42-20.38,19.14-18.9,21.93-26,58.07S426,396,426,396Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.07,272.7a2.58,2.58,0,0,1,.1.38c.07.27.15.63.26,1.1.22,1,.54,2.42.94,4.23s.9,4.1,1.42,6.73,1.15,5.61,1.75,8.93c1.28,6.62,2.62,14.54,4,23.35s2.69,18.53,3.88,28.75,2.08,20,2.78,28.89,1.16,16.91,1.43,23.65c.16,3.37.24,6.42.33,9.1s.14,5,.16,6.87,0,3.32,0,4.34v1.13a2.21,2.21,0,0,1,0,.38,2.28,2.28,0,0,1,0-.38c0-.28,0-.65-.05-1.13,0-1-.08-2.48-.15-4.34s-.12-4.19-.24-6.86-.22-5.73-.41-9.09c-.32-6.74-.85-14.75-1.54-23.63s-1.65-18.64-2.81-28.87-2.53-19.92-3.84-28.73-2.67-16.73-3.9-23.36c-.58-3.32-1.18-6.31-1.68-8.94s-.94-4.9-1.32-6.74-.65-3.26-.85-4.26l-.21-1.11A2.12,2.12,0,0,1,395.07,272.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.76,414.54s-27.31-31-35.79-49.72l6.4-2.73c-4.64.76-9.39-1.23-13-4.26s-6.24-7-8.83-10.94l8.43-1.42a31.38,31.38,0,0,1-18.42-14.27c9.95,1.63,18.95,7.1,26.37,13.93,6,5.53,11.1,12,16,18.52a62.85,62.85,0,0,1,6.21,10.2C398.71,383.34,406.78,403.16,406.76,414.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,298.49a1.91,1.91,0,0,1-.13.31l-.42.9c-.4.82-.95,2-1.67,3.44-1.46,3-3.54,7.3-6.05,12.67s-5.42,11.8-8.53,19-6.38,15.17-9.65,23.6-6.18,16.55-8.74,24-4.72,14.13-6.47,19.8-3.13,10.26-4,13.44c-.46,1.57-.82,2.8-1.08,3.67-.12.39-.22.7-.29.94a1.17,1.17,0,0,1-.12.32,1.42,1.42,0,0,1,.06-.33c.07-.24.15-.56.25-1,.23-.88.56-2.11,1-3.69.86-3.21,2.18-7.82,3.89-13.5s3.85-12.41,6.37-19.84,5.45-15.54,8.7-24,6.58-16.41,9.7-23.61,6.07-13.61,8.64-19,4.68-9.65,6.2-12.6l1.76-3.39.46-.88C465.91,298.58,466,298.48,466,298.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.08,427.82a2.43,2.43,0,0,1-.13-.57c-.07-.43-.15-1-.26-1.64s-.24-1.59-.42-2.6-.36-2.17-.64-3.43c-.49-2.54-1.19-5.53-2.08-8.83s-2.06-6.87-3.44-10.56-2.92-7.12-4.4-10.19-3-5.78-4.27-8c-.63-1.13-1.26-2.11-1.79-3s-1-1.62-1.4-2.23-.65-1-.89-1.41a2.5,2.5,0,0,1-.28-.51,3.21,3.21,0,0,1,.37.45l1,1.36c.42.59.93,1.32,1.48,2.19s1.21,1.84,1.86,3c1.35,2.21,2.85,4.91,4.38,8s3.05,6.53,4.46,10.23,2.51,7.31,3.41,10.61,1.54,6.34,2,8.89c.26,1.27.41,2.43.56,3.45s.27,1.9.34,2.62.12,1.22.17,1.66A2.32,2.32,0,0,1,409.08,427.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.34,
    y: 420.53,
    width: 59.77,
    height: 12.19,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.04 432.73 397.5 473.74 433.62 473.74 439.65 432.73 391.04 432.73",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.45,432.73c0,.14-11.31.26-25.25.26s-25.26-.12-25.26-.26,11.31-.26,25.26-.26S441.45,432.58,441.45,432.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155,121.92c1-4.87,4.43-7.47,9-9.39a15.54,15.54,0,0,1,14.27,1.36c2.78,1.84,5,4.62,8.25,5.5,5.28,1.46,11.08-2.81,16.18-.82a7.07,7.07,0,0,1-2.45,13.65c3.46,1,4.82,5.75,3.05,8.88s-5.74,4.53-9.31,4.11-6.79-2.36-9.61-4.59-5.4-4.77-8.4-6.76-6.56-3.41-10.13-3c-4.83.58-8.76,4.51-10.63,9s-2,9.49-2,14.36.29,9.8-.84,14.54a1.81,1.81,0,0,1-.88,1.39c-.77.29-1.5-.5-1.94-1.2a71.49,71.49,0,0,1-9.9-26c-.9-5.34-1.1-10.44,1.56-15.15s9.9-8.55,13.75-5.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.07,145.05l1,49.71c.19,9.28,4.85,18.88,19.51,17.91h0c12.66-1.8,13-10.68,12.93-21.69h0s13.87-1.59,14.59-15.36c.34-6.66-.06-20.42-.56-32.87a25.69,25.69,0,0,0-24.65-24.62l-1.33,0C154.21,118.35,146.41,130.7,147.07,145.05Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,191a33.34,33.34,0,0,1-17.73-6s3.91,10.86,17.71,10.17Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.68,156.59a2,2,0,0,1-2,1.91,1.87,1.87,0,0,1-1.95-1.85,2,2,0,0,1,2-1.91A1.88,1.88,0,0,1,189.68,156.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.33,149.39c-.25.25-1.7-.92-3.82-1s-3.71.92-3.93.65c-.11-.12.16-.57.85-1a5.38,5.38,0,0,1,3.16-.84,5.22,5.22,0,0,1,3,1.11C191.25,148.81,191.45,149.28,191.33,149.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06,155.73a2,2,0,0,1-2,1.91,1.88,1.88,0,0,1-2-1.85,2,2,0,0,1,2-1.91A1.88,1.88,0,0,1,170.06,155.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5,149c-.25.25-1.7-.91-3.82-1s-3.71.92-3.93.65.16-.57.86-1a5.39,5.39,0,0,1,3.15-.84,5.22,5.22,0,0,1,3,1.11C170.42,148.37,170.62,148.84,170.5,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.56,165a14.26,14.26,0,0,1,3.46-.48c.54,0,1.06-.12,1.17-.49a2.75,2.75,0,0,0-.3-1.61c-.46-1.33-.93-2.72-1.44-4.18-2-6-3.4-10.84-3.16-10.92s2.05,4.68,4,10.64c.47,1.46.93,2.86,1.36,4.2a3.11,3.11,0,0,1,.2,2.13,1.36,1.36,0,0,1-.92.76,4,4,0,0,1-.93.09A13.54,13.54,0,0,1,177.56,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.38,140.68c-.23.56-2.34.21-4.83.41s-4.54.79-4.84.27c-.14-.26.23-.79,1.06-1.31a8.07,8.07,0,0,1,3.63-1.11,8.16,8.16,0,0,1,3.74.59C171,139.94,171.48,140.41,171.38,140.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.8,143.23c-.4.47-1.83-.09-3.59-.18s-3.25.19-3.57-.33c-.14-.25.11-.72.78-1.15a4.9,4.9,0,0,1,2.94-.67,5,5,0,0,1,2.83,1.08C190.79,142.5,191,143,190.8,143.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.79,155.3c-.23-.11-9.36-3.18-9.43,6.26s9.41,7.56,9.43,7.29S147.79,155.3,147.79,155.3Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.93,165.25s-.16.12-.44.24a1.69,1.69,0,0,1-1.23,0c-1-.38-1.82-2-1.85-3.67a5.4,5.4,0,0,1,.48-2.35,1.91,1.91,0,0,1,1.24-1.25.84.84,0,0,1,1,.46c.12.27.06.45.11.47s.21-.16.13-.55A1,1,0,0,0,144,158a1.26,1.26,0,0,0-.91-.25,2.32,2.32,0,0,0-1.73,1.45,5.57,5.57,0,0,0-.59,2.63c.05,1.9,1,3.68,2.37,4.09a1.75,1.75,0,0,0,1.5-.24C144.91,165.48,145,165.27,144.93,165.25Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.24,129.92a18,18,0,0,0-5.52-6.9A30.71,30.71,0,0,0,172.17,116a25,25,0,0,0-17.79,5.92,26.48,26.48,0,0,0-7.79,13,38.91,38.91,0,0,0-.7,15.28c.31,2.23.82,4.55,2.31,6.24.93,1.06,2.58,1.79,3.72,1a3.72,3.72,0,0,0,1.19-2.13c2.1-7.2,4.2-14.94,1.82-22.05a21.42,21.42,0,0,1,6.73-5.7,11.14,11.14,0,0,1,8.6-.83c4.15,1.46,6.57,5.65,9.81,8.62A19.91,19.91,0,0,0,197.59,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.6,170.86a9.41,9.41,0,0,1-1,2.46,3.17,3.17,0,0,1-2.16,1.45,2.85,2.85,0,0,1-2.48-1.15,4.59,4.59,0,0,1-.85-2.68c0-.86.31-1.91,1.16-2.06a2,2,0,0,1,1.05.16l4.6,1.52",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,174.67a6.38,6.38,0,0,1-2.41-.14,3.42,3.42,0,0,1-1.91-1.52,3.61,3.61,0,0,1-.25-2.93,3.17,3.17,0,0,1,.34-.69c.17-.2.13-.19.33-.18s.49.16.74.24l.75.25c1,.32,1.88.61,2.63.83a8.52,8.52,0,0,0,2.49.58,8.06,8.06,0,0,0-2.3-1.11c-.73-.3-1.6-.63-2.57-1l-.75-.27c-.27-.09-.48-.2-.84-.29a1,1,0,0,0-.66.07,1.23,1.23,0,0,0-.47.42,3.85,3.85,0,0,0-.45.88,4.22,4.22,0,0,0,.37,3.58,3.84,3.84,0,0,0,2.4,1.69,3.72,3.72,0,0,0,1.95-.05C176.88,174.88,177.07,174.71,177.05,174.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.52,120.9a2.85,2.85,0,0,1,.1.63,6.6,6.6,0,0,1-.2,1.84,8.65,8.65,0,0,1-4.16,5.21c-2.53,1.49-6.24,1.71-9.87.62s-7.19-3.38-10.89-5.56-7.58-3.83-11.29-3.68a14.82,14.82,0,0,0-8.92,3.56,19.66,19.66,0,0,0-4.3,5c-.8,1.36-1.13,2.18-1.18,2.15a2.47,2.47,0,0,1,.2-.6,15.75,15.75,0,0,1,.77-1.67,18.92,18.92,0,0,1,4.23-5.24,15.08,15.08,0,0,1,9.19-3.79c3.87-.19,7.89,1.53,11.6,3.71s7.18,4.51,10.75,5.55,7.07.91,9.5-.46a8.55,8.55,0,0,0,4.14-4.9A9.38,9.38,0,0,0,205.52,120.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74,140.53a6.68,6.68,0,0,1,.73-2.51,16,16,0,0,1,3.59-5.18,16.33,16.33,0,0,1,2.76-2.14,5.83,5.83,0,0,1,2.73-1,3.09,3.09,0,0,1,1.9.49c.39.27.51.51.48.53a3.61,3.61,0,0,0-2.35-.59c-1.5.16-3.36,1.5-5.09,3.12a18.67,18.67,0,0,0-3.63,4.93C141.13,139.61,140.84,140.56,140.74,140.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.07,148.89a7,7,0,0,1,.88-2.47,17.45,17.45,0,0,1,3.86-5,17.73,17.73,0,0,1,5.42-3.33,7.19,7.19,0,0,1,2.55-.62,25.18,25.18,0,0,1-2.39,1,21,21,0,0,0-5.17,3.39,20.69,20.69,0,0,0-3.89,4.79C142.53,148,142.16,148.93,142.07,148.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.44 285.1 261.61 305.31 253.61 319.64 196.72 310.91 211.44 285.1",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,226.71c.26,14.11-.2,48.11-.2,48.11l8,12.64-14.07,19-16.26,2.29-1.61,12.61s-28.49,12.75-51.28,5c-17.73-6-38.45,14.21-38.45,14.21s-1.9-3.3,1.18-31.82c2.93-27.19,8-72.06,8-72.06l16.39-41L148,191.4c10.31,17.52,30.92,17.62,32.58,7l16.37,6.81a23.27,23.27,0,0,1,14.64,21.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.35,231c.14,0-1.59,16.21-3.86,36.16s-4.24,36.12-4.38,36.1,1.58-16.2,3.86-36.16S197.21,231,197.35,231Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.23,267.55c.08.12-8,5.43-18,11.86S153.11,291,153,290.83s8-5.43,18-11.86S189.15,267.43,189.23,267.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.46 473.74 151 473.74 145.6 410.17 160.46 410.17 160.46 473.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.81 473.74 77.36 473.74 71.96 410.17 86.81 410.17 86.81 473.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.94 473.74 255.49 473.74 250.09 410.17 264.94 410.17 264.94 473.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.73,353.52l9-137.82h-85a10.35,10.35,0,0,0-10.17,12.23L60.77,412.54c10.88-.15,209.15,0,209.15,0v-59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.81,392.23c0,.15-18.84.26-42.07.26s-42.07-.11-42.07-.26,18.83-.26,42.07-.26S238.81,392.09,238.81,392.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,424.3l6.11,29.18s31.72,3.58,33.37,8.86L297.4,476.23,286,431.16Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.22,455.34a2.37,2.37,0,0,0-.94,3,2.28,2.28,0,0,0,3,1,2.5,2.5,0,0,0,1-3.2,2.35,2.35,0,0,0-3.2-.65",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.66,477.43l-1.11-4.37,54.08-13s2.77.47,2.92,2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,453c.06.27-1.28.74-2.41,1.95s-1.56,2.55-1.84,2.5-.26-1.73,1.13-3.18S321,452.7,321,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.52,453.94c.12.25-.95,1-1.59,2.4s-.61,2.69-.89,2.74-.83-1.45,0-3.16S327.44,453.68,327.52,453.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,460.17c-.23.11-1-1.16-.62-2.84s1.47-2.59,1.64-2.39-.42,1.2-.67,2.58S332.87,460.07,332.6,460.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.89,446.47c-.05.28-1.4.21-2.93.7s-2.61,1.28-2.81,1.08.72-1.47,2.52-2S319,446.22,318.89,446.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M314.07,424.3l6.11,29.18s31.72,3.58,33.37,8.86l-55.89,15.09L286,431.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.23,336.32l35.55,103.19-30.7,11.35L232.52,337.75l-94-14.7L195,307.87l80.44,20.33A12.58,12.58,0,0,1,284.23,336.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,412.84l20.3,22.29S362.86,422,367,425.74L325.2,466.65l-33.05-33.44Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.68,446a2.39,2.39,0,0,0,.73,3.1,2.29,2.29,0,0,0,3.08-.69,2.52,2.52,0,0,0-.78-3.28c-1.06-.52-2.78-.05-3.13,1.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,467.56l-3.2-3.24,40.46-39.09s2.65-1,3.73.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.85,434.25c.2.22-.73,1.31-1.09,2.95s-.06,3-.33,3.12-1.12-1.37-.64-3.35S333.72,434,333.85,434.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,431.78c.24.15-.31,1.36-.16,2.9s.85,2.66.64,2.85-1.48-.84-1.63-2.76S339.82,431.59,340,431.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,434.59c-.14.22-1.42-.52-2-2.15s0-3,.2-2.92.25,1.26.73,2.59S347.83,434.37,347.64,434.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.66,429.69c.1.27-1.11.9-2.19,2.11s-1.62,2.45-1.9,2.38-.12-1.65,1.17-3.05S328.61,429.43,328.66,429.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,366.52l81.94-.34,90.94,84.68,28.27-26.33s-77.22-87.14-86.14-96.13-94.88-15-94.88-15L96.88,335.87l1.18,5.86A30.82,30.82,0,0,0,128.43,366.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.46,355.41a25,25,0,0,1,.88,5,24.39,24.39,0,0,1,.36,5.06,25.67,25.67,0,0,1-.88-5A25.22,25.22,0,0,1,208.46,355.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.14,414a10,10,0,0,1-1,1.19c-.68.74-1.68,1.8-2.93,3.09-2.5,2.59-6,6.11-10,9.9s-7.65,7.13-10.36,9.51c-1.35,1.19-2.45,2.14-3.23,2.78a9.35,9.35,0,0,1-1.23,1,8.33,8.33,0,0,1,1.1-1.11c.8-.75,1.85-1.73,3.12-2.9,2.64-2.45,6.27-5.83,10.24-9.61s7.52-7.27,10.08-9.79l3.05-3A8.06,8.06,0,0,1,320.14,414Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,422.84s.19.15.54.47l1.56,1.42,6,5.52,22.12,20.48h-.25l28.23-26.37,0,.33c-11.91-13.9-26.18-29.11-41.13-45.29-6.61-7.14-13-14.13-19.22-20.93s-12-13.42-17.41-19.94a53.89,53.89,0,0,0-8.49-8.81,22.45,22.45,0,0,0-5-2.93,31.63,31.63,0,0,0-5.42-1.67c-3.65-.78-7.25-1.24-10.69-1.8l-9.89-1.54-29.84-4.67-8.11-1.3-2.1-.35c-.48-.08-.72-.14-.72-.14s.25,0,.72.09l2.12.3,8.12,1.2,29.87,4.51,9.9,1.5c3.43.55,7,1,10.71,1.78a31.89,31.89,0,0,1,5.5,1.68,22.39,22.39,0,0,1,5.15,3,53.93,53.93,0,0,1,8.58,8.87c5.37,6.49,11.26,13.1,17.42,19.9S282,371.9,288.65,379.05c15,16.18,29.21,31.4,41.11,45.33l.15.17-.17.16c-10.64,9.88-20.26,18.81-28.3,26.29l-.13.11-.12-.11-22-20.61-5.93-5.58c-.66-.64-1.17-1.12-1.53-1.46S271.22,422.84,271.22,422.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,301l-24.72,8.33-45.51-18.51-24.3,22.59,64.92,11.65a14.16,14.16,0,0,0,6.56-.47l19.14-6s6.25,7.07,7.56,7.17,3.94-.07,2.68-2.41a61,61,0,0,0-4.47-6.39s8.79,7.25,9.79,6.28.6-3.22-1-5.05-6.73-7.76-6.73-7.76,10.83,9,11.86,7.61,1.54-3.51-2.8-7.67c-2.85-2.73-7.23-6.63-9.54-8.66A3.53,3.53,0,0,0,199.3,301Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.91,309.56a17.53,17.53,0,0,1-2.36,2.92A17.63,17.63,0,0,1,169,315.2a11,11,0,0,1,2.19-3.06A11.37,11.37,0,0,1,173.91,309.56Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.37,318.66a9.76,9.76,0,0,1-2.08-2.13c-1.2-1.4-2.78-3.39-4.56-5.54s-3.35-4.4-5.33-4a4.22,4.22,0,0,0-2,.6,6.64,6.64,0,0,1-.66.44s.13-.28.55-.61a4.1,4.1,0,0,1,2.07-.8,4.48,4.48,0,0,1,1.56.13,2.5,2.5,0,0,1,.83.39c.22.19.48.38.69.6a34,34,0,0,1,2.68,2.94c1.79,2.16,3.33,4.18,4.44,5.64L209.9,318C210.21,318.42,210.4,318.63,210.37,318.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.83,312.32s.15-.25.58-.52a3.76,3.76,0,0,1,2-.52,3.88,3.88,0,0,1,1.47.29,3.51,3.51,0,0,1,1.31,1.12c.37.47.68,1,1,1.51s.76,1,1.15,1.54c3.22,4.23,5.61,7.85,5.4,8,0,0-.19-.21-.48-.6l-1.23-1.64L200,316.05c-.39-.54-.79-1-1.16-1.57s-.65-1.05-1-1.5a3.22,3.22,0,0,0-1.11-1,3.91,3.91,0,0,0-1.3-.31A4.53,4.53,0,0,0,192.83,312.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,311a13,13,0,0,1-2-1.59c-1.19-1-2.82-2.48-4.59-4.1l-2.49-2.3a7.77,7.77,0,0,0-2.13-1.64,4.47,4.47,0,0,0-2.42-.35s.21-.17.66-.24a3.74,3.74,0,0,1,1.9.25,5.5,5.5,0,0,1,1.17.65c.39.29.75.62,1.14,1l2.52,2.27c1.77,1.63,3.36,3.12,4.49,4.22A11.55,11.55,0,0,1,212.94,311Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.47,314s-9.24-10.38-8.66-24.22,4.55-53.9,6.32-64.89,10-26,23.2-29.26C133,193.28,135,222.41,135,222.41l-7.27,64.31,14.5,8.42-13.53,22.92Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.7,219.2c-.1,0-.22-1.4-.83-3.59a25.39,25.39,0,0,0-1.37-3.74,29.08,29.08,0,0,0-2.46-4.2,27.79,27.79,0,0,0-3.22-3.64,24.71,24.71,0,0,0-3.12-2.48c-1.89-1.26-3.2-1.82-3.16-1.91a3.92,3.92,0,0,1,.94.33,8.27,8.27,0,0,1,1.07.51,14.09,14.09,0,0,1,1.35.76,22.17,22.17,0,0,1,3.24,2.43,25.19,25.19,0,0,1,3.32,3.7,25.49,25.49,0,0,1,2.47,4.3,22,22,0,0,1,1.3,3.84,14.09,14.09,0,0,1,.3,1.53,8.59,8.59,0,0,1,.15,1.16A3.32,3.32,0,0,1,133.7,219.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,286.77a19.06,19.06,0,0,1-2.29,1.33,54.16,54.16,0,0,0-5.34,3.46,57.16,57.16,0,0,0-4.86,4.11,18.68,18.68,0,0,1-2,1.78,11.11,11.11,0,0,1,1.7-2.05,38.91,38.91,0,0,1,4.81-4.26,35.69,35.69,0,0,1,5.48-3.36A10.16,10.16,0,0,1,127.65,286.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.65,272.11l-15.91,57.76H282l18.1-55a3.35,3.35,0,0,0-3.14-4.39l-70.06-.8A3.33,3.33,0,0,0,223.65,272.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.46,269.67c.14,0-3.46,13.54-8.05,30.17s-8.41,30.07-8.55,30,3.47-13.55,8-30.17S228.32,269.63,228.46,269.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.16,298.86a3.14,3.14,0,1,0,4.35-1.85A3.37,3.37,0,0,0,257.16,298.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.74,329.87H158.05a4.25,4.25,0,0,1,4.25-4.25h47.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.81,289.82a2.84,2.84,0,0,1,0,.47c0,.33,0,.79,0,1.37s.07,1.33.15,2.21.25,1.86.43,3a38,38,0,0,0,2.5,7.84,39,39,0,0,0,5.67,9.21l-.12-.06,26.18,4-.25.12L139,300.06l3-5.05.1.36-14.5-8.43-.13-.08v-.16c1.33-14.72,2.47-27.38,3.29-36.39.42-4.47.76-8,1-10.51.12-1.2.22-2.13.29-2.8,0-.3.06-.54.08-.72a1.74,1.74,0,0,1,0-.24.73.73,0,0,1,0,.24c0,.19,0,.43,0,.73-.05.66-.12,1.6-.2,2.81-.2,2.48-.49,6-.85,10.52-.77,9-1.85,21.68-3.1,36.4l-.13-.23,14.51,8.41.22.13-.13.22-3,5.06-10.56,17.86-.09.15-.16,0-26.17-4.08h-.08l0-.05a38.9,38.9,0,0,1-8.09-17.28,28.42,28.42,0,0,1-.38-3,21.11,21.11,0,0,1-.1-2.22c0-.58,0-1,0-1.37A2.84,2.84,0,0,1,93.81,289.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,307.87s87.83,11.12,91,14.2c2.76,2.7,6.27,74,7.05,73.7l-82-3.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07,412.33c-.15,0-2-20.57-4.09-46s-3.71-46-3.56-46,2,20.56,4.08,46S129.21,412.32,129.07,412.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.33,215.7a1.63,1.63,0,0,1,.11.35l.24,1,.89,3.9c.77,3.43,1.85,8.33,3.2,14.38,2.65,12.18,6.3,29,10.34,47.49,1,4.63,2,9.16,2.92,13.54.47,2.19.94,4.33,1.39,6.44.11.52.22,1.05.34,1.57a8.33,8.33,0,0,0,.39,1.49,4.66,4.66,0,0,0,1.91,2.2,4.75,4.75,0,0,0,1.35.53c.46.11,1,.15,1.47.22l2.94.39,5.62.73,10.09,1.34,14.59,2,4,.56,1,.15a1.5,1.5,0,0,1,.35.08l-.36,0-1-.11-4-.46-14.62-1.81-10.09-1.27-5.63-.71-2.94-.37c-.5-.07-1-.11-1.51-.22a5.33,5.33,0,0,1-1.49-.59,5.06,5.06,0,0,1-2.12-2.42,9.54,9.54,0,0,1-.43-1.58c-.11-.52-.22-1-.34-1.57-.45-2.1-.92-4.25-1.4-6.43-.94-4.38-1.92-8.91-2.93-13.54-4-18.55-7.58-35.33-10.19-47.52-1.28-6.06-2.31-11-3-14.41-.35-1.68-.61-3-.8-3.93-.08-.43-.15-.77-.2-1S39.33,215.71,39.33,215.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.89,327.74c.15,0,1.82,19,3.75,42.38s3.37,42.41,3.22,42.42-1.82-19-3.74-42.38S148.75,327.75,148.89,327.74Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 55.04,
    width: 203.68,
    height: 178.35,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.89,
    y: 136.87,
    width: 203.18,
    height: 96.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.31,114.42c0,.14-27.88.26-62.25.26s-62.26-.12-62.26-.26,27.87-.26,62.26-.26S416.31,114.27,416.31,114.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.9,74.34c0,.14-45.11.26-100.75.26s-100.76-.12-100.76-.26,45.1-.26,100.76-.26S452.9,74.19,452.9,74.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.42,
    cy: 64.32,
    r: 3.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 271.76,
    cy: 64.32,
    r: 3.09,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,64.32a3.09,3.09,0,1,1-3.09-3.09A3.09,3.09,0,0,1,285.19,64.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.34,
    cy: 113.87,
    r: 8.13,
    transform: "translate(2.47 233.7) rotate(-45)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,109.79v7.87h-1.82v-6.41h-1.57v-1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.21,114.14a21.6,21.6,0,0,0-.47-2.87,11.77,11.77,0,0,0-4.31-6.39,11.64,11.64,0,0,0-11-1.63,11,11,0,0,0-2.93,1.58,10.84,10.84,0,0,0-2.45,2.47,11.52,11.52,0,0,0,0,13.68,10.84,10.84,0,0,0,2.45,2.47,11,11,0,0,0,2.93,1.58,11.7,11.7,0,0,0,15.31-8,21.63,21.63,0,0,0,.47-2.86,4.41,4.41,0,0,1,0,.76,5.37,5.37,0,0,1-.07.91,8.15,8.15,0,0,1-.22,1.24A11.95,11.95,0,0,1,355.6,126a12.06,12.06,0,0,1-6.33-.5,11.65,11.65,0,0,1-3.07-1.63,11.35,11.35,0,0,1-2.56-2.57,12,12,0,0,1,0-14.29,11.51,11.51,0,0,1,2.56-2.56,11.65,11.65,0,0,1,3.07-1.63,12.06,12.06,0,0,1,6.33-.5,11.95,11.95,0,0,1,9.34,8.93,8.25,8.25,0,0,1,.22,1.23,5.47,5.47,0,0,1,.07.92A4.41,4.41,0,0,1,365.21,114.14Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.55,113.87c-.06,0,0-.73-.35-2a8.16,8.16,0,0,0-3-4.36,7.91,7.91,0,0,0-7.5-1.09,7.75,7.75,0,0,0-3.65,2.75,7.85,7.85,0,0,0,0,9.31,7.84,7.84,0,0,0,3.65,2.76,7.94,7.94,0,0,0,7.5-1.1,8.18,8.18,0,0,0,3-4.35c.33-1.24.29-2,.35-2a1.7,1.7,0,0,1,0,.52,6.64,6.64,0,0,1-.19,1.49,8.22,8.22,0,0,1-6.43,6.18,8.33,8.33,0,0,1-4.39-.33,8.25,8.25,0,0,1-3.9-2.91,8.31,8.31,0,0,1,0-9.91,8.25,8.25,0,0,1,3.9-2.91,8.33,8.33,0,0,1,4.39-.33,8.21,8.21,0,0,1,6.43,6.19,6.5,6.5,0,0,1,.19,1.48A1.8,1.8,0,0,1,432.55,113.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.35,
    y: 113.52,
    width: 78.98,
    height: 1.43,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.38,
    cy: 113.87,
    r: 8.13,
    transform: "translate(184.24 444.37) rotate(-80.76)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.45,116.18v1.48H350.5v-1.18l3-2.87c.7-.66.82-1.07.82-1.45,0-.62-.42-1-1.26-1a1.94,1.94,0,0,0-1.63.79l-1.32-.85a3.64,3.64,0,0,1,3.12-1.47c1.76,0,2.93.9,2.93,2.33a3.16,3.16,0,0,1-1.32,2.49l-1.81,1.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.51,115.25c0,1.33-1,2.55-3.26,2.55a5.43,5.43,0,0,1-3-.85l.71-1.39a3.84,3.84,0,0,0,2.25.71c.91,0,1.47-.37,1.47-1s-.43-1-1.47-1h-.83v-1.21l1.62-1.83h-3.35v-1.46h5.51V111l-1.78,2A2.25,2.25,0,0,1,427.51,115.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.54,88.28c0,.14-19.78.26-44.17.26s-44.18-.12-44.18-.26S334,88,358.37,88,402.54,88.13,402.54,88.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.95 138.04 354.06 129.75 360.16 138.04 347.95 138.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.07,233.39c0-1.85-.09-71-.22-178.35l.22.22-203.66,0h0l.26-.26c0,64.8,0,125.83,0,178.35l-.23-.23,203.67.23-203.67.23h-.23v-.23c0-52.52,0-113.55,0-178.35v-.26h.27l203.66,0h.22V55C454.16,162.35,454.07,231.54,454.07,233.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.16,157.72c0,.14-6.22.26-13.88.26s-13.88-.12-13.88-.26,6.21-.27,13.88-.27S301.16,157.57,301.16,157.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.66,180.12H277.2a7.11,7.11,0,0,1-7.11-7.11h0a7.11,7.11,0,0,1,7.11-7.11h52.46a7.11,7.11,0,0,1,7.12,7.11h0A7.11,7.11,0,0,1,329.66,180.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.24,157.72c0,.14-5.89.26-13.15.26s-13.15-.12-13.15-.26,5.88-.27,13.15-.27S398.24,157.57,398.24,157.72Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.43,196.49c0,.14-5.89.26-13.15.26s-13.15-.12-13.15-.26,5.88-.26,13.15-.26S300.43,196.34,300.43,196.49Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.94,180.12H372.47a7.11,7.11,0,0,1-7.11-7.11h0a7.11,7.11,0,0,1,7.11-7.11h52.47a7.11,7.11,0,0,1,7.11,7.11h0A7.11,7.11,0,0,1,424.94,180.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.88,219.48H277.59a7.11,7.11,0,0,1-7.12-7.11h0a7.11,7.11,0,0,1,7.12-7.11H426.88a7.11,7.11,0,0,1,7.12,7.11h0A7.11,7.11,0,0,1,426.88,219.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452.9,
    cy: 57.08,
    r: 14.78,
    transform: "translate(92.29 336.97) rotate(-45)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.78,
    y: 49.97,
    width: 2.96,
    height: 13.28,
    transform: "translate(172.77 -303.91) rotate(45)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.78,
    y: 49.97,
    width: 2.96,
    height: 13.28,
    transform: "translate(92.72 337.08) rotate(-45)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupAlHalal);
export default __webpack_public_path__ + "static/media/signupAlHalal.31fec3fc0b40a2ddca7c4aad878def6f.svg";
export { ForwardRef as ReactComponent };